(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pp-checkout-upsell"] && !Shopify.designMode) return;
  try {
    if (!window.ppCheckoutUpsellReady) {
    window.ppCheckoutUpsellReady = true;

    const SEEN_KEY = 'pp-checkout-upsell-seen';
    let bypass = false;

    const wasSeen = () => {
      try {
        return sessionStorage.getItem(SEEN_KEY) === '1';
      } catch (error) {
        return false;
      }
    };

    const markSeen = () => {
      try {
        sessionStorage.setItem(SEEN_KEY, '1');
      } catch (error) {
        /* Nur Komfortfunktion */
      }
    };

    const track = (name, detail) => {
      try {
        if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
          window.Shopify.analytics.publish(name, detail);
        }
      } catch (error) {
        /* Analytics duerfen nie stoeren */
      }
    };

    const goToCheckout = (trigger, dialog) => {
      bypass = true;
      if (trigger && trigger.isConnected && trigger.form) {
        trigger.form.requestSubmit(trigger);
      } else {
        window.location.href = (dialog && dialog.dataset.checkoutUrl) || '/checkout';
      }
    };

    const open = (dialog, trigger) => {
      const yes = dialog.querySelector('[data-pp-cu-yes]');
      const no = dialog.querySelector('[data-pp-cu-no]');
      const close = dialog.querySelector('[data-pp-cu-close]');
      const error = dialog.querySelector('[data-pp-cu-error]');

      markSeen();

      yes.onclick = async () => {
        yes.disabled = true;
        yes.setAttribute('aria-busy', 'true');
        try {
          const response = await fetch(dialog.dataset.addUrl || '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ items: [{ id: Number(dialog.dataset.variantId), quantity: 1 }] }),
          });
          if (!response.ok) throw new Error('add failed');
          track('pp_upsell_add', { source: 'checkout_popup', variant: dialog.dataset.variantId });
          window.location.href = dialog.dataset.checkoutUrl || '/checkout';
        } catch (err) {
          error.hidden = false;
          window.setTimeout(() => goToCheckout(trigger, dialog), 1800);
        }
      };

      no.onclick = () => {
        track('pp_checkout_upsell_decline', {});
        dialog.close();
        goToCheckout(trigger, dialog);
      };

      close.onclick = () => dialog.close();
      dialog.onclick = (event) => {
        if (event.target === dialog) dialog.close();
      };

      dialog.showModal();
      yes.focus();
      track('pp_checkout_upsell_view', {});
    };

    document.addEventListener(
      'click',
      (event) => {
        if (bypass) return;
        const trigger = event.target.closest('button[name="checkout"]');
        if (!trigger || trigger.disabled || wasSeen()) return;

        const dialog = document.querySelector('dialog[data-pp-checkout-upsell]');
        if (!dialog || typeof dialog.showModal !== 'function') return;

        /* Nur anzeigen, wenn das Popup sichtbar werden kann (z. B. Warenkorb-Drawer ist offen) */
        const host = dialog.parentElement && dialog.parentElement.closest('dialog');
        if (host && !host.open) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        open(dialog, trigger);
      },
      true
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pp-policy"] && !Shopify.designMode) return;
  try {
    /* Rechtsseiten: Inhaltsverzeichnis, Pseudo-Ueberschriften, Stand-Pille, Drucken (snippets/pp-policy.liquid) */
  if (!customElements.get('pp-policy')) {
    const CLOCK =
      '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"><circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/></svg>';

    /* "ABSCHNITT 3 – BESTELLUNGEN": Nummer und Titel */
    const SECTION = /^ABSCHNITT\s*(\d+)\s*[–—:.-]?\s*(.*)$/i;

    /* Naechster Nachbar ohne reine Leerzeichen-Textknoten */
    const sibling = (node, dir) => {
      let n = node[dir];
      while (n && n.nodeType === 3 && !n.textContent.trim()) n = n[dir];
      return n;
    };

    customElements.define(
      'pp-policy',
      class extends HTMLElement {
        connectedCallback() {
          this.rte = this.querySelector('.shopify-policy__body .rte');
          if (!this.rte) return;
          this.cleanUp();
          this.markStamps();
          this.buildToc();

          const print = this.querySelector('[data-print]');
          if (print) {
            print.hidden = false;
            print.addEventListener('click', () => window.print());
          }
        }

        disconnectedCallback() {
          this.observer?.disconnect();
          this.mql?.removeEventListener('change', this.onMedia);
        }

        /* Leere Bloecke und Zeilenumbrueche am Textende (z. B. Kontaktinformationen) entfernen */
        cleanUp() {
          this.rte.querySelectorAll('div, p').forEach((el) => {
            if (!el.textContent.trim() && !el.querySelector('img, svg, iframe, table')) el.remove();
          });
          let last = this.rte.lastChild;
          while (last && (last.nodeName === 'BR' || (last.nodeType === 3 && !last.textContent.trim()))) {
            const prev = last.previousSibling;
            last.remove();
            last = prev;
          }
        }

        markStamps() {
          this.rte.querySelectorAll('p').forEach((p) => {
            if (/^(Letzte Fassung|Stand)\s*:/i.test(p.textContent.trim()) && p.textContent.length < 80) {
              p.classList.add('pp-policy__stamp');
              p.insertAdjacentHTML('afterbegin', CLOCK);
            }
          });
          /* Stand-Angabe der IT-Recht Kanzlei (Impressum) */
          const itk = this.rte.querySelector('#itkanzlei_txt_copyright > div');
          if (itk) {
            itk.classList.add('pp-policy__stamp');
            itk.insertAdjacentHTML('afterbegin', CLOCK);
          }
        }

        /* Fett gesetzte Zeile zwischen Zeilenumbruechen, ueberwiegend in Grossbuchstaben = Ueberschrift */
        pseudoHeadings() {
          const found = [];
          this.rte.querySelectorAll('strong, b').forEach((el) => {
            const text = el.textContent.replace(/\s+/g, ' ').trim();
            if (text.length < 3 || text.length > 90 || el.closest('li, h1, h2, h3, h4')) return;
            const letters = text.replace(/[^A-Za-zÄÖÜäöüß]/g, '');
            const caps = letters && letters.replace(/[^A-ZÄÖÜ]/g, '').length / letters.length >= 0.7;
            if (!caps && !SECTION.test(text)) return;
            const prev = sibling(el, 'previousSibling');
            const next = sibling(el, 'nextSibling');
            if (prev && prev.nodeName !== 'BR') return;
            if (next && next.nodeName !== 'BR') return;
            found.push(el);
          });

          return found.map((el) => {
            /* Umbrueche um die Ueberschrift uebernimmt der Abstand */
            let n = sibling(el, 'nextSibling');
            if (n?.nodeName === 'BR') n.remove();
            n = sibling(el, 'previousSibling');
            while (n?.nodeName === 'BR') {
              const prev = sibling(n, 'previousSibling');
              n.remove();
              n = prev;
            }

            const text = el.textContent.replace(/\s+/g, ' ').trim();
            const match = text.match(SECTION);
            el.classList.add('pp-policy__h');
            el.setAttribute('role', 'heading');
            el.setAttribute('aria-level', '2');
            if (match) {
              el.dataset.num = match[1];
              el.dataset.label = match[2];
              el.textContent = '';
              el.insertAdjacentHTML(
                'afterbegin',
                `<span class="pp-policy__h-num"><span class="pp-sr-only">Abschnitt </span>${match[1]}</span><span></span>`
              );
              el.lastChild.textContent = match[2];
            }
            return el;
          });
        }

        buildToc() {
          let items = [...this.rte.querySelectorAll('h2')];
          if (items.length < 3) items = [...this.rte.querySelectorAll('h2, h3')];
          if (items.length < 3) items = this.pseudoHeadings();
          if (items.length < 3) return;

          const toc = this.querySelector('[data-toc]');
          const list = this.querySelector('[data-toc-list]');
          const count = this.querySelector('[data-toc-count]');
          if (!toc || !list) return;

          const links = new Map();
          const used = new Set();
          items.forEach((el, i) => {
            const label = el.dataset.label || el.textContent.replace(/\s+/g, ' ').trim();
            if (!el.id) {
              let id =
                'abschnitt-' +
                label
                  .toLowerCase()
                  .replace(/ä/g, 'ae')
                  .replace(/ö/g, 'oe')
                  .replace(/ü/g, 'ue')
                  .replace(/ß/g, 'ss')
                  .replace(/[^a-z0-9]+/g, '-')
                  .replace(/^-|-$/g, '')
                  .slice(0, 48);
              if (used.has(id) || id === 'abschnitt-') id += '-' + (i + 1);
              el.id = id;
            }
            used.add(el.id);

            const li = document.createElement('li');
            const a = document.createElement('a');
            a.href = '#' + el.id;
            a.className = 'pp-policy__toc-link pp-focus' + (el.tagName === 'H3' ? ' pp-policy__toc-link--sub' : '');
            if (el.dataset.num) {
              const num = document.createElement('span');
              num.className = 'pp-policy__toc-num';
              num.textContent = el.dataset.num;
              a.append(num);
            }
            const span = document.createElement('span');
            span.textContent = label;
            if (label === label.toUpperCase()) span.className = 'pp-policy__toc-label--caps';
            a.append(span);
            li.append(a);
            list.append(li);
            links.set(el, a);
          });

          if (count) count.textContent = `· ${items.length} Abschnitte`;
          toc.hidden = false;

          /* Ab 990px immer offen; mobil schliesst ein Klick auf einen Eintrag das Verzeichnis */
          this.mql = window.matchMedia('(min-width: 990px)');
          this.onMedia = () => (toc.open = this.mql.matches);
          this.onMedia();
          this.mql.addEventListener('change', this.onMedia);
          list.addEventListener('click', (event) => {
            if (event.target.closest('a') && !this.mql.matches) toc.open = false;
          });

          /* Aktuellen Abschnitt markieren */
          let current = null;
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                current?.removeAttribute('aria-current');
                current = links.get(entry.target);
                current?.setAttribute('aria-current', 'true');
                if (this.mql.matches && current) {
                  const box = list.getBoundingClientRect();
                  const r = current.getBoundingClientRect();
                  if (r.top < box.top || r.bottom > box.bottom) {
                    list.scrollTop += r.top - box.top - box.height / 2;
                  }
                }
              });
            },
            { rootMargin: '-15% 0px -75% 0px' }
          );
          items.forEach((el) => this.observer.observe(el));
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pp-product-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.ppProductGallery) return;
    window.ppProductGallery = true;

    // Weitere Galeriebilder sind lazy (konkurrieren nicht mit dem ersten Bild); nach dem Laden der Seite
    // holen, damit sie beim Wischen schon da sind. Zoom-Fenster bleibt aussen vor.
    const loadRestOfGallery = () => {
      document
        .querySelectorAll('media-gallery img.product-media__image[loading="lazy"]')
        .forEach((image) => {
          if (!image.closest('.dialog-zoomed-gallery')) image.loading = 'eager';
        });
    };
    if (document.readyState === 'complete') loadRestOfGallery();
    else window.addEventListener('load', loadRestOfGallery, { once: true });

    const desktop = window.matchMedia('(min-width: 750px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const ZOOM_SCALE = 2.5;
    const SWIPE_DISTANCE = 50;

    const chevron = (path) =>
      `<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"><path d="${path}"/></svg>`;

    /** @param {HTMLElement} zoom */
    const enhance = (zoom) => {
      if (zoom.dataset.ppGallery === 'ready') return;

      const dialog = zoom.querySelector('dialog');
      const list = dialog?.querySelector('.dialog-zoomed-gallery');
      if (!dialog || !list) return;
      zoom.dataset.ppGallery = 'ready';

      const items = () => /** @type {HTMLElement[]} */ ([...list.children]);
      const count = items().length;
      let index = 0;

      const counter = document.createElement('p');
      counter.className = 'pp-zoom-counter';
      counter.setAttribute('aria-live', 'polite');

      const render = () => {
        counter.textContent = `${index + 1} / ${count}`;
      };

      // ---- Zoom per Klick (Desktop) ----
      /** @type {HTMLElement | null} */
      let zoomed = null;
      /** @type {DOMRect | null} */
      let zoomRect = null;

      const setOrigin = (/** @type {MouseEvent} */ event) => {
        if (!zoomed || !zoomRect) return;
        const x = Math.min(100, Math.max(0, ((event.clientX - zoomRect.left) / zoomRect.width) * 100));
        const y = Math.min(100, Math.max(0, ((event.clientY - zoomRect.top) / zoomRect.height) * 100));
        zoomed.style.setProperty('--pp-zoom-x', `${x}%`);
        zoomed.style.setProperty('--pp-zoom-y', `${y}%`);
      };

      const zoomOut = () => {
        if (!zoomed) return;
        zoomed.classList.remove('pp-zoomed', 'pp-zooming');
        zoomed = null;
        zoomRect = null;
      };

      const zoomIn = (/** @type {HTMLElement} */ item, /** @type {HTMLImageElement} */ image, /** @type {MouseEvent} */ event) => {
        zoomOut();
        zoomed = item;
        zoomRect = image.getBoundingClientRect();
        item.style.setProperty('--pp-zoom-scale', String(ZOOM_SCALE));
        setOrigin(event);
        item.classList.add('pp-zoomed');
        // Erst nach der Zoom-Animation der Maus ohne Verzoegerung folgen
        window.setTimeout(() => zoomed === item && item.classList.add('pp-zooming'), reducedMotion.matches ? 0 : 300);
      };

      // ---- Blaettern ----
      const go = (/** @type {number} */ next) => {
        if (count < 2) return;
        zoomOut();
        index = (next + count) % count;
        render();
        zoom.selectThumbnail(index, { behavior: reducedMotion.matches ? 'instant' : 'smooth' });
      };

      if (count > 1) {
        const button = (/** @type {string} */ modifier, /** @type {string} */ label, /** @type {string} */ path, /** @type {number} */ step) => {
          const el = document.createElement('button');
          el.type = 'button';
          el.className = `pp-zoom-nav pp-zoom-nav--${modifier}`;
          el.setAttribute('aria-label', label);
          el.innerHTML = chevron(path);
          el.addEventListener('click', () => go(index + step));
          return el;
        };

        dialog.append(
          counter,
          button('prev', 'Vorheriges Bild', 'M15 5l-7 7 7 7', -1),
          button('next', 'Nächstes Bild', 'M9 5l7 7-7 7', 1)
        );

        dialog.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          if (event.target instanceof HTMLElement && event.target.closest('input, textarea, select, model-viewer')) return;
          event.preventDefault();
          const forward = (event.key === 'ArrowRight') !== (document.dir === 'rtl');
          go(index + (forward ? 1 : -1));
        });

        // Wischen auf dem Handy, solange das Bild nicht per Pinch/Doppeltipp vergroessert ist
        let touchStart = /** @type {{ x: number, y: number } | null} */ (null);
        list.addEventListener(
          'touchstart',
          (event) => {
            touchStart = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
          },
          { passive: true }
        );
        list.addEventListener(
          'touchend',
          (event) => {
            if (!touchStart || desktop.matches) return;
            const touch = event.changedTouches[0];
            const dx = touch.clientX - touchStart.x;
            const dy = touch.clientY - touchStart.y;
            touchStart = null;
            if (Math.abs(dx) < SWIPE_DISTANCE || Math.abs(dx) < Math.abs(dy) * 1.5) return;

            const wrapper = items()[index]?.querySelector('drag-zoom-wrapper');
            const scale = parseFloat(wrapper?.style.getPropertyValue('--drag-zoom-scale') || '1');
            if (scale > 1.01) return;

            const forward = (dx < 0) !== (document.dir === 'rtl');
            go(index + (forward ? 1 : -1));
          },
          { passive: true }
        );
      }

      // Index mit Horizon synchron halten (Thumbnail-Klick, Oeffnen)
      zoom.addEventListener('zoom-media:selected', (event) => {
        const next = /** @type {CustomEvent} */ (event).detail?.index;
        if (typeof next !== 'number' || next === index) return;
        zoomOut();
        index = next;
        render();
      });

      new MutationObserver(() => {
        if (dialog.open) {
          // Horizon scrollt beim Oeffnen synchron zum Bild; daraus den Startindex lesen und die
          // Thumbnail-Markierung nachziehen (ohne View Transition setzt Horizon sie nicht)
          const width = list.clientWidth || 1;
          index = Math.min(count - 1, Math.round(Math.abs(list.scrollLeft) / width));
          render();
          zoom.selectThumbnail(index, { behavior: 'instant' });
        } else {
          zoomOut();
        }
      }).observe(dialog, { attributes: true, attributeFilter: ['open'] });

      // Desktop: Klick aufs Bild zoomt statt zu schliessen, Klick daneben schliesst (Horizon).
      // Fenster-Capture laeuft vor Horizons document-Capture-Delegation.
      window.addEventListener(
        'click',
        (event) => {
          if (!desktop.matches || !dialog.open) return;
          const target = /** @type {Element} */ (event.target);
          if (!(target instanceof Element) || !list.contains(target)) return;

          const item = /** @type {HTMLElement | null} */ (target.closest('.product-media-container--image'));
          if (!item) return;

          if (zoomed) {
            event.stopPropagation();
            zoomOut();
            return;
          }

          const image = target.closest('.product-media__image');
          if (!(image instanceof HTMLImageElement)) return;
          event.stopPropagation();
          zoomIn(item, image, /** @type {MouseEvent} */ (event));
        },
        { capture: true }
      );

      list.addEventListener('mousemove', setOrigin);
      list.addEventListener('mouseleave', () => zoomed?.classList.remove('pp-zooming'));
      list.addEventListener('mouseenter', () => zoomed?.classList.add('pp-zooming'));
      desktop.addEventListener('change', zoomOut);

      render();
    };

    const scan = () => document.querySelectorAll('zoom-dialog').forEach((el) => enhance(/** @type {HTMLElement} */ (el)));

    customElements.whenDefined('zoom-dialog').then(() => {
      scan();
      // Variantenwechsel rendert die Galerie neu; gebuendelt pro Frame nachziehen
      let queued = false;
      new MutationObserver(() => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => {
          queued = false;
          scan();
        });
      }).observe(document.body, { childList: true, subtree: true });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pp-rocket-fly"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.ppRocketLanding) return;
    window.ppRocketLanding = true;
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const ROCKET = /fly-to-cart--(main|quick|sticky)/;
    const BITS = ['★', '✦', '♥', '★', '✦', '♥', '★', '✦', '♥', '★', '✦', '♥', '✦', '★'];
    const COLORS = ['#e8303a', '#2f7cf0', '#ffd23f', '#ff8a1c'];

    const land = () => {
      const icon = document.querySelector('.header-actions__cart-icon');
      if (!icon) return;
      const r = icon.getBoundingClientRect();
      const x = r.left + r.width / 2;
      const y = r.top + r.height / 2;

      icon.classList.remove('pp-cart-land');
      void icon.offsetWidth;
      icon.classList.add('pp-cart-land');
      icon.addEventListener('animationend', () => icon.classList.remove('pp-cart-land'), { once: true });

      const add = (el) => {
        el.style.left = `${x}px`;
        el.style.top = `${y}px`;
        document.body.appendChild(el);
        el.addEventListener('animationend', () => el.remove(), { once: true });
      };

      const ring = document.createElement('span');
      ring.className = 'pp-land-fx pp-land-fx--ring';
      add(ring);

      BITS.forEach((char, i) => {
        const angle = (i / BITS.length) * Math.PI * 2 + Math.random() * 0.5;
        const dist = 45 + Math.random() * 35;
        const bit = document.createElement('span');
        bit.className = 'pp-land-fx pp-land-fx--bit';
        bit.textContent = char;
        bit.style.setProperty('--dx', `${Math.cos(angle) * dist}px`);
        bit.style.setProperty('--dy', `${Math.sin(angle) * dist}px`);
        bit.style.setProperty('--rot', `${Math.random() * 180 - 90}deg`);
        bit.style.setProperty('--size', `${15 + Math.random() * 10}px`);
        bit.style.setProperty('--color', COLORS[i % COLORS.length]);
        add(bit);
      });
    };

    const watch = () =>
      new MutationObserver((mutations) => {
        for (const m of mutations) {
          for (const node of m.removedNodes) {
            if (node.localName === 'fly-to-cart' && ROCKET.test(node.className)) land();
          }
        }
      }).observe(document.body, { childList: true });

    if (document.body) watch();
    else document.addEventListener('DOMContentLoaded', watch, { once: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pp-ship-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pp-ship-countdown')) {
    class PpShipCountdown extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        const { signal } = this.abortController;
        if (window.ppDelivery) this.start();
        else document.addEventListener('pp:delivery-ready', () => this.start(), { once: true, signal });
      }

      disconnectedCallback() {
        if (this.abortController) this.abortController.abort();
        clearInterval(this.timer);
      }

      start() {
        if (!this.isConnected || !window.ppDelivery) return;
        this.config = window.ppDelivery.readConfig(this);
        this.update();
        this.timer = setInterval(() => this.update(), 30000);
        document.addEventListener(
          'visibilitychange',
          () => {
            if (!document.hidden) this.update();
          },
          { signal: this.abortController.signal }
        );
      }

      update() {
        const core = window.ppDelivery;
        if (!core || !core.formatShipDay) return;
        const result = core.compute(this.config);
        const template = this.dataset.tplBefore;
        const values = {
          countdown: core.formatCountdown(result.minutesToCutoff ?? result.minutesLeft),
          shipday: core.formatShipDay(result.shipDate, result.today),
        };
        const parts = (template || '').split(/(\{countdown\}|\{shipday\})/);
        const text = this.querySelector('[data-text]');
        text.replaceChildren(
          ...parts.map((part) => {
            const key = part.slice(1, -1);
            if (!(part.startsWith('{') && key in values)) return part;
            const strong = document.createElement('strong');
            strong.textContent = values[key];
            return strong;
          })
        );
        this.hidden = false;
      }
    }

    customElements.define('pp-ship-countdown', PpShipCountdown);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pp-slide-a11y"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.ppSlideA11y) return;
    window.ppSlideA11y = true;

    const FOCUSABLE =
      'a[href], button, input, select, textarea, summary, [tabindex]:not([tabindex="-1"])';

    const sync = (slide) => {
      if (slide.getAttribute('aria-hidden') === 'true') {
        for (const el of slide.querySelectorAll(FOCUSABLE)) {
          if (el.hasAttribute('data-pp-tabindex')) continue;
          el.setAttribute('data-pp-tabindex', el.getAttribute('tabindex') ?? '');
          el.setAttribute('tabindex', '-1');
        }
      } else {
        for (const el of slide.querySelectorAll('[data-pp-tabindex]')) {
          const previous = el.getAttribute('data-pp-tabindex');
          if (previous === '') el.removeAttribute('tabindex');
          else el.setAttribute('tabindex', previous);
          el.removeAttribute('data-pp-tabindex');
        }
      }
    };

    const syncWithin = (root) => {
      if (root.localName === 'slideshow-slide') sync(root);
      root.querySelectorAll('slideshow-slide[aria-hidden]').forEach(sync);
    };

    const start = () => {
      syncWithin(document.body);
      new MutationObserver((records) => {
        for (const record of records) {
          if (record.type === 'attributes') {
            if (record.target.localName === 'slideshow-slide') sync(record.target);
            continue;
          }
          /* Per Section Rendering / Morph neu eingefuegte Karussells */
          for (const node of record.addedNodes) {
            if (node.nodeType === 1) syncWithin(node);
          }
        }
      }).observe(document.body, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['aria-hidden'],
      });
    };

    if (document.body) start();
    else document.addEventListener('DOMContentLoaded', start, { once: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
